<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        {{ id?'编辑':'新增'}}巡查点
      </div>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      :rules="rules"
      class="mt20"
    >
      <div class="f-right border-b">
        <div class="flex1">基本信息</div>
      </div>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-row>
            <el-form-item
              prop="areaId"
              label-width="160px"
              label="所属区域(部门)"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <!-- <el-input v-model="form.c_point_area"></el-input>
               -->

              <el-select v-model="form.areaId">
                <el-option
                  v-for="(item, index) in areaList"
                  :label="item.areaName"
                  :value="item.areaId"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label-width="160px"
              prop="pointNum"
              label="巡查点编号"
             
           
            >
              <el-input  disabled v-model="form.pointNum"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label-width="160px"
              prop="pointName"
              label="巡查点名称"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-input v-model="form.pointName"></el-input>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="pointAddr"
              label="巡查点位置"
            >
              <el-input v-model="form.pointAddr"></el-input>
            </el-form-item>
            <!-- <el-form-item
              label-width="160px"
              prop="pointBasic"
              label="巡查点设备"
            >
              <el-input v-model="form.pointBasic"></el-input>
            </el-form-item> -->
            <el-form-item label-width="160px" prop="nfcNum" label="NFC编号">
              <el-input v-model="form.nfcNum"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="nfcNum" label="GPS定位">
              <div style="display:flex">
                <span style="width:100px">东经</span
                ><el-input v-model="form.base.lon"></el-input>
                <span style="width:100px;margin-left:15px"> 北纬</span
                ><el-input v-model="form.base.lat"></el-input>
              </div>

              <div>
                <getLoation @callback="getLoa" :local="form.base"></getLoation>
              </div>
            </el-form-item>
            <!-- <el-form-item label-width="160px" label="GPS范围">
              <el-select v-model="form.gpsArea" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
          </el-row>
        </el-col>
      </el-row>
      <div class="f-right border-b">
        <div class="flex1">巡检检查内容</div>
      </div>
      <div class="flex ml20">
        <el-col :span="11">
          <h3 class="ml20 mt10">巡查标准</h3>
          <div class="ml20 flex1 mt20" style="padding-left: 50px">
            <!-- :check-strictly='true' -->
            <el-tree
              :data="list"
              ref="tree1"
              node-key="id"
              show-checkbox
              @check-change="handleCheckChange"
              :props="defaultProps"
              class="tree"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-input
                  v-if="data.isEdit"
                  v-model="data.label"
                  size="mini"
                ></el-input>
                <span style="font-size:13px" v-else>{{node.label  }} </span>
                <span v-if="!data.isSelf" class="mt20">
                  <el-button
                    class="mt20"
                    type="text"
                    v-if="node.id"
                    size="mini"
                    @click.native="() => changeNodeStatus(node, data, 1)"
                    v-hasPermi="[
                      'relic:relicInspectionListMain:customUpdateFather',
                    ]"
                  >
                    编辑
                  </el-button>

                  <el-button
                    type="text"
                    size="mini"
                    @click.native="() => changeNodeStatus(node, data, 0)"
                    v-hasPermi="['relic:customRemoveFather:remove']"
                  >
                    删除
                  </el-button>
                </span>
              </span>
            </el-tree>
            <el-button
              type="primary"
              size="small"
              @click="addTree()"
              v-hasPermi="['relic:relicInspectionListMain:customUpdateFather']"
              v-if="id"
              >添加自定义</el-button
            >
          </div>
        </el-col>
        <!-- <el-col class="ml20" :span="11">
          <h3 class="ml20 mt10">本次巡查点标准</h3>

          <el-tree
            :data="list2"
            show-checkbox
            ref="tree2"
            class="tree"

          >
          </el-tree>
        </el-col> -->
      </div>
    </el-form>

    <div class="btn-box">
      <div
        class="l-btn"
        @click="onSubmit"
        v-hasPermi="['relic:relicInspectionPoint:addAndUpdate']"
      >
        保存
      </div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
    <el-dialog
      :visible.sync="showAddList"
      title="自定义巡查标准"
      width="40%"
      :show-close="false"
    >
      <div style="height:600px;overflow:auto">
        <el-button
          class="btn ml10"
          size="small"
          icon="icon-tr-newly-added"
          type="primary"
          @click="addTree(true)"
        >
          新增
        </el-button>
        <el-tree
          :data="addList"
          ref="tree2"
          node-key="id"
          :expand-on-click-node="false"
          class="tree mt10"
        >
          <span
            class="custom-tree-node"
            style="padding:20px"
            slot-scope="{ node, data }"
          >
            <el-input v-model="data.label" size="mini"></el-input>
            <span v-if="!data.isSelf" class="mt20">
              <el-button
                class="mt20"
                type="text"
                v-if="node.level !== 2"
                size="mini"
                @click.native="() => append(node, data)"
              >
                增加
              </el-button>

              <el-button
                type="text"
                size="mini"
                @click.native="() => remove(node, data, addList)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div>
        <el-button
          type="primary"
          @click="saveAppend"
          v-hasPermi="['relic:relicInspectionListMain:customUpdateFather']"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";
import getLoation from "../company/getLoation";

export default {
  data() {
    return {
      options: [
        {
          value: "20",
          label: "20",
        },
        {
          value: "40",
          label: "40",
        },
        {
          value: "60",
          label: "60",
        },
      ],
      id: this.$route.query.id || "",
      areaId: this.$route.query.areaId || "",
      cpNum: this.$route.query.cnum || "",
      expandedArr: [],
      expandAuto: true,
      showAddList: false,
      addList: [],

      form: {
        areaId: null,
        areaName: "",
        companyNum: this.$route.query.cnum || "",
        gpsArea: "",
        gpsLat: "",
        gpsLon: "",
        id: null,
        nfcNum: "",
        pointAddr: "",
        pointArea: "",
        pointBasic: "",
        pointName: "",
        pointNum: "",
        remark: "",
        status: null,
        base: {
          lat: "",
          lon: "",
        },
        inspectionList: [],
      },
      rules: {},
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],
      list: [],
      areaList: [],
    };
  },
  created() {
    if (this.areaId) {
      this.form.areaId = this.areaId;
    }
    if (this.cpNum) {
      this.getList();
    }
  },
  mounted() {},
  components: {
    getLoation,
  },
  methods: {
    defaultProps(){
      this.$nextTick(() => {
        const arr = []
        this.form.inspectionList.forEach(item => {
          if (!this.$refs.tree1.getNode(item).childNodes ||!this.$refs.tree1.getNode(item).childNodes.length) {
            arr.push(item)
          }
        })
        this.$refs.tree1.setCheckedKeys(arr)
      })
    },
    getLoa(val) {
      // log(val,222222222222)
      this.form.base.lon = String(val[0]);
      this.form.gpsLon = String(val[0]);
      this.form.base.lat = String(val[1]);
      this.form.gpsLat = String(val[1]);
    },
    // 弹框的编辑删除
    changeNodeStatus(node, data, state) {
      console.log(node, data);
      if (state) {
        // 编辑
        this.addList = [
          {
            label: node.data.label,
            checklist: node.data.label,
            uid: node.data.uid,
            id: node.data.id,
            isSelf: false,
            level: node.level,
            children: node.data.children,
            disabled: true,
          },
        ];
        console.log(this.addList, 111111111);
        if (!this.showAddList) {
          this.showAddList = true;
        }
        this.expandAuto = true;

        // if (data.isEdit) {
        //   // 保存
        //   this.$put("/checklist/checkListMainPoint/", data).then((res) => {
        //     this.$message({message: res.msg,type: "success", duration: 700,});
        //     data.isEdit = !data.isEdit;
        //   });
        //   console.log("保存");
        // } else {
        //   data.isEdit = !data.isEdit;
        // }
      } else {
        // 删除
        console.log(node.level);
        let url =
          node.level == 1
            ? "/relicInspectionListMain/relicInspectionListMain/customRemoveFather/"
            : "/relicInspectionListMain/relicInspectionListMain/customRemoveSon/";
        this.$remove(url + data.id).then((res) => {
          this.$message({ message: res.msg, type: "success", duration: 700 });
          this.remove(null, data, this.list);
        });
        console.log("shanchu");
      }
    },
    addTree(type) {
      console.log(type, this.addList);
      // this.addList.length < 1 ||
      if (type == true) {
        this.addList.push({
          label: "",
          uid: new Date().getTime(),
          isSelf: false,
          level: 1,
          checklist: "",
          children: [],
          disabled: true,
        });
      } else {
        this.addList = [];
      }

      if (!this.showAddList) {
        this.showAddList = true;
      }
      this.expandAuto = true;
    },
    saveAppend(node, data) {
      console.log(
        node,
        data,
        this.addList,
        this.$route.query.areaId,
        "this.$route.query.areaId"
      );
      // 递归改数据，给后端想要的格式
      function change(params) {
        for (let i = 0; i < params.length; i++) {
          if (params[i].children) {
            params[i].childTreeList = params[i].children;
            params[i].checklist = params[i].label;
            change(params[i].childTreeList);
          } else if (params[i].label) {
            params[i].checklist = params[i].label;
          }
        }
      }
      change(this.addList);
      console.log(this.addList, "this.addList");
      let url;
      var obj = {
        companyNum: this.$route.query.cnum,
        pointId: this.$route.query.id,
        childTreeList: this.addList,
      };
      if (this.addList[0].level == 1) {
        if (this.addList[0].id) {
          this.$put(
            "/relicInspectionListMain/relicInspectionListMain/customUpdateFather",
            obj
          )
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                  duration: 700,
                });
                this.getList(1);
                this.expandAuto = true;
                this.showAddList = false;
                this.addList = [];
              }
            })
            .catch((e) => {
              // console.log(e);
            });
        } else {
          this.$post(
            "/relicInspectionListMain/relicInspectionListMain/custom",
            obj
          )
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                  duration: 700,
                });
                this.getList(1);
                this.expandAuto = true;
                this.showAddList = false;
                this.addList = [];
              }
            })
            .catch((e) => {
              // console.log(e);
            });
        }
      } else {
        // 子项
        this.$put(
          "/relicInspectionListMain/relicInspectionListMain/customUpdateSon",
          this.addList[0]
        ).then((res) => {
          console.log(res, "子检查项修改");
          this.getList(1);
          this.expandAuto = true;
          this.showAddList = false;
          this.addList = [];
        });
      }
    },
    append(node, data) {
      console.log(node, data, "data");
      if (data.level == 2) return;
      // data.id = node.id;
      // let newid=node.childNodes[node.childNodes.length-1]
      node.expanded = true;
      if (data.children == undefined) {
        data.children = [];
      }
      data.children.push({
        label: "",
        pId: data.uid,
        uid: new Date().getTime(),
        isSelf: false,
        level: 2,
        children: [],
        disabled: true,
        // time: new Date().getTime(),
        // id:newid
      });
    },
    remove(node, data, list) {
      console.log(node, data, list, this.addList);
      list = list ? list : this.addList;
      // console.log(data);
      if (data.pId || data.uid) {
        // 还未调接口 自己
        if (data.pId) {
          // 删除的子项
          console.log("zixiang");
          list.map((item) => {
            console.log(item.uid, data.pId);
            if (item.uid == data.pId) {
              item.children.map((it, ind) => {
                if (it.uid == data.uid) {
                  item.children.splice(ind, 1);
                }
              });
            }
          });
        } else {
          // 删除父项
          console.log("父项");
          list.map((item, index) => {
            if (item.uid === data.uid) {
              list.splice(index, 1);
            }
          });
        }
      } else {
        console.log("保存过 调接口");
      }
    },
    save() {
      console.log(this.id, this.form, "this.form");
      if (!this.form.inspectionList.length) {
        this.$message.warning("请至少选择一项检查项");
      } else {
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");

        if (reg.test(this.form.pointNum)) {
          this.$message.error("巡查点编号不可以为中文！");
          return;
        }
         this.form.gpsLat = this.form.base.lat
         this.form.gpsLon = this.form.base.lon
        this.form.pointId = this.$route.query.id || "";
        this.$post("/relic/relicInspectionPoint", this.form).then((res) => {
          console.log(res, 1111);
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 700,
          });
          this.$router.back();
        });
        // var url = this.id ? "/patrol/patrolupdate" : "/patrol/patroladd";
        // this.$post(url, this.form).then((res) => {
        //   // this.$message.success("操作成功");
        //   this.$message({
        //     message: "操作成功",
        //     type: "success",
        //     duration: 700,
        //   });
        //   this.$router.back();
        // });
      }
    },

    onSubmit() {
      console.log(this.form);
      this.$refs.tree1.getHalfCheckedKeys();
      var arr = this.$refs.tree1
        .getCheckedKeys()
        .concat(this.$refs.tree1.getHalfCheckedKeys());
      // console.log(arr);
      this.form.inspectionList = arr;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });

      //    this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     this.save();
      //   } else {
      //     this.nowIndex = 0;
      //     return false;
      //   }
      // });

      // this.$refs.form.validate((valid) => {
      //               if (valid) {
      //                 this.save()
      //               } else {
      //                   console.log('error submit!!');
      //                   this.$message.warning('请填写必填项')
      //                   return false;
      //               }
      //           });
    },
    handleCheckChange(v, b) {
      // console.log(v.id);
      // console.log(v)
      this.CheckedKeys = this.$refs.tree1.getCheckedKeys();
      this.$refs.tree1.getCheckedKeys();
    },
    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    getList(only) {
      console.log(this.$route.query.areaId, "getlisty");
      this.loading = true;
      let url = this.id
        ? "/relicInspectionListMain/relicInspectionListMain/customRegularFindTree"
        : "/relicInspectionListMain/relicInspectionListMain/findTree";
      this.$get(url, {
        companyNum: this.$route.query.cnum,
        pointId: this.$route.query.id,
      })
        .then((res) => {
          console.log(res, "findtree2");
          var arr = [];

          res.data.map((item) => {
            var obj = {
              id: item.id,
              label: item.checklist,
              isSelf: item.type,
              isEdit: false,
              uid: item.id,
            };
            if (item.childTreeList) {
              item.childTreeList.map((ite) => {
                var obj2 = {
                  id: ite.id,
                  label: ite.checklist,
                  isSelf: ite.type,
                  isEdit: false,
                  pId: ite.huuid,
                  uid: ite.id,
                };
                obj.children
                  ? obj.children.push(obj2)
                  : (obj.children = [obj2]);
              });
            }

            arr.push(obj);
            // console.log(arr,'arr');
          });
          this.list = arr;
          console.log(this.list, "44444444444");

          // console.log(this.list);
          if (only) {
            this.$refs.tree1.setCheckedKeys(this.CheckedKeys);
            return (this.loading = false);
          }
          // this.total = res.data.count
          // this.list = res.data.list
          // this.loading = false
          if (this.id) {
            this.$get(`/relic/relicInspectionPoint/${this.id}`).then((res) => {
              this.form = { ...this.form, ...res.data };
              console.log(this.form, 2222);
              this.form.base.lat = this.form.gpsLat;
              this.form.base.lon = this.form.gpsLon;

              // this.form.patrol = res.list.patrol[0];
              // this.form.get_rate = res.list.rate;
              // this.form.inspectionList = res.list.item;
              // var arr1 = [];
              // var resArr = [];
              // this.form.inspectionList.map((item) => {
              //   resArr.push(item);
              // });
              console.log(this.list, "this.list");
              // this.list.map((it) => {
              // if (this.form.inspectionList.indexOf(it.id) > -1) {
              //   resArr.splice(resArr.indexOf(it.id), 1);
              // }
              // });
              this.defaultProps()

              // this.$refs.tree1.setCheckedKeys(this.form.inspectionList,true);
            });
          }
        })
        .catch((err) => {});
      // 所属区域
      this.$get(
        "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + this.cpNum
      ).then((res) => {
        console.log(res, 111111111);
        this.areaList = res.data;
      });
    },
    open(lng, lat) {
      if (lng && lat) {
        this.center = [lng, lat];
        this.marker.position = [lng, lat];
      }
      this.dialogVisible = true;
    },
    onSearchResult(pois) {
      let latSum = 0;
      let lngSum = 0;
      pois.forEach((poi) => {
        lngSum += poi.lng;
        latSum += poi.lat;
      });
      let center = {
        lng: lngSum / pois.length,
        lat: latSum / pois.length,
      };
      this.center = [center.lng, center.lat];
      this.marker.position = [center.lng, center.lat];
    },
    submit() {
      // log(this.marker.position);
      this.$emit("callback", this.marker.position);
      this.dialogVisible = false;
    },
    // 弹窗关闭时
    closeHandle() {},
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}

.tree {
  font-size: 18px;
  margin-bottom: 20px;
}
::v-deep .el-tree-node {
 word-break: break-all;
  white-space: pre-line;
 width: 90vw;
}
::v-deep .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 100%;
  width: 90vw;
  cursor: pointer;
   word-break: break-all;
    white-space: pre-line;
 
}

</style>
